import * as utils from './utils';

export const useUtils = () => ({
  ...utils,
});

export const _ = null;
